export class PriceUploadExcelViewModel {
    areaCode: string;
    WeightCode:string;
    price: number;
}


// WEBPACK FOOTER //
// C:/Users/LIVE02/Documents/SSW/ThanhBuoi/TBE_CRM/src/app/view-model/priceUploadExcel.viewModel.ts